import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import arrowIcon from "../../assets/right-arrow.png";
import useMembersStore from "../../store/members.store";
import { Tooltip } from "antd";
import { MenuOutlined, LeftOutlined  } from "@ant-design/icons";

import "./sidebar.scss";
import HomeSidebar from "./HomeSidebar";
import NuJobsSidebar from "./NuJobsSidebar";
import QHRFlowSidebar from "./QHRFlowSidebar";
import EvaluationMarketPlace from "./EvaluationMarketPlace";

function Sidebar() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [isHomeCollapsed, setIsHomeCollapsed] = useState(true);
  const [isQHRFlowCollapsed, setIsQHRFlowCollapsed] = useState(true);
  const [isNuJobsCollapsed, setIsNuJobsCollapsed] = useState(true);
  const [isCollapsedTeam, setIsCollapsedTeam] = useState(true);
  const [isCollapsedMy, setIsCollapsedMy] = useState(true);
  const [isCollapsedAllResume, setIsCollapsedAllResume] = useState(true);
  const [isCollapsedInterviews, setIsCollapsedInterviews] = useState(true);
  const [isCollapsedSourcing, setIsCollapsedSourcing] = useState(true);
  const [isCollapsedJD, setIsCollapsedJD] = useState(true);
  const [isCollapsedSelections, setIsCollapsedSelections] = useState(true);
  const [isCollapsedEvaluations, setIsCollapsedEvaluations] = useState(true);

  const { currSubscription } = useMembersStore();
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const subscriptionIsActive =
    userDetails.permission != "superuser" ||
    currSubscription === "trial_active" ||
    currSubscription === "subscription_active";

  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector(".navbar-wrapper");
      const breadcrumb = document.querySelector(".breadcrumbs");
      const headerHeight = header?.offsetHeight;

      if (window.scrollY > headerHeight) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleToggleCollapseTeam = () => {
    setIsCollapsedTeam(!isCollapsedTeam);
  };
  const handleToggleCollapseMy = () => {
    setIsCollapsedMy(!isCollapsedMy);
  };
  const handleToggleCollapseAllResume = () => {
    setIsCollapsedAllResume(!isCollapsedAllResume);
  };
  const handleToggleCollapseInterviews = () => {
    setIsCollapsedInterviews(!isCollapsedInterviews);
  };
  const handleToggleCollapseSourcing = () => {
    setIsCollapsedSourcing(!isCollapsedSourcing);
  };
  const handleToggleCollapsejd = () => {
    setIsCollapsedJD(!isCollapsedJD);
  };

  const handleToggleCollapseSelections = () => {
    setIsCollapsedSelections(!isCollapsedSelections);
  };

  const handleToggleCollapseEvaluations = () => {
    setIsCollapsedEvaluations(!isCollapsedEvaluations);
  };

  function getTimeNow() {
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    const currentDate = date + "-" + month + "-" + year;
    return currentDate;
  }

  function getDay() {
    const weekday = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    const today = new Date();
    const day = today.getDay();
    return weekday[day];
  }

  return (
    <div className="sidebar-container">
      {sidebarOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setSidebarOpen(false)}
        ></div>
      )}
      <div
        className={`sidebar-wrapper ${sidebarOpen ? "active" : ""} ${
          isSticky ? "sticky" : ""
        }`}
        style={{ borderRadius: "0px" }}
      >
        {/* <Link className="sidebar-link" to="/interviews">
                Job Descriptions
            </Link> */}

        <div
          className="sidebar-menu-wrapper"
          onClick={() => setSidebarOpen(!sidebarOpen)}
        >
          <div className="sidebar-menu-btn">
            {sidebarOpen ? <LeftOutlined  /> : <MenuOutlined />}
          </div>
        </div>

        {sidebarOpen && (
          <>
            {
              userDetails.productsignon.toLowerCase().includes("qhrflow")?
              <>
                  <hr className="sidebar-hr"></hr>       
                  <div className="sideFont datetime-display">
                    <span className="date">{getDay()}</span>
                    <span className="time">{getTimeNow()}</span>
                  </div>      
                   <hr className="sidebar-hr"></hr>        
                  <QHRFlowSidebar
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                    subscriptionIsActive={subscriptionIsActive}
                  />     
                  {
                    userDetails.productsignon.toLowerCase().includes("nujobs")?
                    <>                
                      <NuJobsSidebar
                        sidebarOpen={sidebarOpen}
                        setSidebarOpen={setSidebarOpen}
                        subscriptionIsActive={subscriptionIsActive}
                      />    
                    </>
                    :<></>
                  }
                  {
                     userDetails.permission == "superuser"?
                     <>
                        <EvaluationMarketPlace
                          sidebarOpen={sidebarOpen}
                          setSidebarOpen={setSidebarOpen}
                          subscriptionIsActive={subscriptionIsActive}
                        />                      
                     </>
                     :<></>
                  }                          
              </>
              :userDetails.productsignon.toLowerCase().includes("nujobs")?
              <>
                <hr className="sidebar-hr"></hr>       
                <div className="sideFont datetime-display">
                    <span className="date">{getDay()}</span>
                    <span className="time">{getTimeNow()}</span>
                </div>                
                <NuJobsSidebar
                  sidebarOpen={sidebarOpen}
                  setSidebarOpen={setSidebarOpen}
                  subscriptionIsActive={subscriptionIsActive}
                />              
              </>
              :<>
              </>
            }
          </>
        )}
      </div>
    </div>
  );
}

export default Sidebar;
